/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { node, object, bool } from 'prop-types';
import Swiper from 'swiper';
import classNames from 'clsx';

import ArrowIcon from 'gfx/vector/arrow-icon.svg';

import styles from './slideshow.scss';

/**
 * This is the Slideshow component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export default class Slideshow extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    children: node.isRequired,
    hasCenteredSlidesMobile: bool,
    settings: object,
  };

  static defaultProps = {
    hasCenteredSlidesMobile: false,
    settings: {},
  };

  /**
   * Create StartPage.
   *
   * @param {object} props
   *
   * @return {void}
   */
  constructor(props) {
    super(props);

    this.swiper = null;
  }

  componentDidMount() {
    const { settings } = this.props;

    process.nextTick(() => {
      this.swiper = new Swiper(this.slideshow, {
        containerModifierClass: styles.container,
        wrapperClass: styles.slides,
        slideClass: styles.slide,
        navigation: {
          nextEl: this.nextButton,
          prevEl: this.prevButton,
        },
        ...settings,
      });
    });
  }

  componentWillUnmount() {
    if (this.swiper) {
      this.swiper.destroy();
    }
  }

  /**
   * Render Slideshow.
   *
   * @return {Object}
   */
  render() {
    const { children, hasCenteredSlidesMobile } = this.props;

    return (
      <div className={styles.wrapper}>
        <div
          className={styles.container}
          ref={ref => {
            this.slideshow = ref;
          }}
        >
          <div
            className={classNames(styles.slides, {
              [styles.centered]: hasCenteredSlidesMobile,
            })}
          >
            {children.map((child, i) => (
              <div key={`slide-${i}`} className={styles.slide}>
                {child}
              </div>
            ))}
          </div>
        </div>

        <button
          className={styles.prevButton}
          ref={ref => {
            this.prevButton = ref;
          }}
        >
          <ArrowIcon />
        </button>
        <button
          className={styles.nextButton}
          ref={ref => {
            this.nextButton = ref;
          }}
        >
          <ArrowIcon />
        </button>
      </div>
    );
  }
}
